
export default {
    // 手机号验证
    phone: str => /^1[3456789][0-9]{9}$/.test(str),
    // 邮箱验证
    email: str => /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+$/.test(str),
    // 密码验证
    password: str => /^[\S]{6,16}$/.test(str),
    // 身份证验证
    idCard: str => /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(str)
}